// Sizing/color come from the `IconTile` wrapper the icon is rendered into (see IconTile size="m").
export const ruleIconClassName = 'shrink-0'
